import { render, staticRenderFns } from "./goalsTable.vue?vue&type=template&id=70e94443&scoped=true"
import script from "./goalsTable.vue?vue&type=script&lang=js"
export * from "./goalsTable.vue?vue&type=script&lang=js"
import style0 from "./goalsTable.vue?vue&type=style&index=0&id=70e94443&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e94443",
  null
  
)

export default component.exports